export default "__VITE_ASSET__QUVcD6oW__"